import { CardIdDto } from '../card/card-id-dto.model';
import { AmountDto } from '../transverse/amount-dto.model';

export class PurchaseVoucherReservationCreate {
  cards: Array<CardIdDto>;
  amount: AmountDto;
  merchantId: string;
}
